import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string | boolean | number;
}
interface DropdownStatusNewProps {
  name?: string;
  initialValue?: any | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  classNamePrefix?: string;
  isHasOptionAll?: boolean;
  optionAll?: undefined | Option;
  colors?: any;
  optionHide?: any;
  isMulti?: any;
}

const CustomMenuList =
  (option: any) =>
  ({ children, ...props }: any) => {
    if (children?.length) {
      const limitedOptions = children?.filter(
        (i: any) => !option?.includes(i?.props?.value)
      );
      return (
        <div
          {...props.innerProps}
          className="overflow-auto"
          style={{ maxHeight: "320px" }}
        >
          {limitedOptions}
        </div>
      );
    } else {
      return (
        <div
          {...props.innerProps}
          className="overflow-auto"
          style={{ maxHeight: "320px" }}
        >
          {children}
        </div>
      );
    }
  };

const DropdownStatusNew = ({
  name = "",
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = "",
  classNamePrefix = "",
  isHasOptionAll = false,
  optionAll,
  colors = {},
  optionHide = [],
  isMulti = false,
}: DropdownStatusNewProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    if (dataList?.length) {
      const result: any = isHasOptionAll
        ? [optionAll].concat(dataList)
        : dataList;
      setOptions((_prev: any) => result);
    }
  }, [dataList, i18n?.language]);

  return (
    <React.Fragment>
      <Select
        options={options}
        value={
          initialValue || initialValue === 0 || isHasOptionAll
            ? options.find((item: any) => item.value === initialValue) ||
              initialValue
            : null
        }
        isMulti={isMulti}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ""}</div>}
        loadingMessage={() => <div>{t("Loading")}...</div>}
        noOptionsMessage={() => <div>{t("No Options")}</div>}
        formatOptionLabel={(option: any) => (
          <div className="d-flex align-items-center" style={{ zIndex: 999 }}>
            {!!Object.values(colors)?.length && (
              <span
                className={`bg-${
                  option?.value !== "" && option?.value !== "all"
                    ? colors?.[option?.value]
                    : "secondary"
                }`}
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "3px",
                  background: colors?.[option?.value],
                }}
              ></span>
            )}
            <div className="ms-2">{t(option?.label)}</div>
          </div>
        )}
        components={{ MenuList: CustomMenuList(optionHide) }}
        className={className}
        classNamePrefix={classNamePrefix}
      />
    </React.Fragment>
  );
};

export default DropdownStatusNew;
